module.exports = __webpack_public_path__ + "static/img/content_3.b959aaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qiwei/content_3.png
// module id = 204p
// module chunks = 94